<template>
  <PageLayout :title="$t('admin.features_title')" :subtitle="$t('admin.features_subtitle')">
    <ContentCard>
      <div v-if="loading" class="text-muted">{{ $t('common.loading') }}</div>
      <form v-else @submit.prevent="save">
        <p class="text-muted mb-4">{{ $t('admin.features_hint') }}</p>

        <div class="custom-control custom-switch mb-3">
          <input id="hide-scheduler" v-model="form.hide_scheduler" type="checkbox" class="custom-control-input" />
          <label class="custom-control-label" for="hide-scheduler">
            {{ $t('admin.hide_scheduler') }}
          </label>
          <small class="form-text text-muted">{{ $t('admin.hide_scheduler_hint') }}</small>
        </div>

        <div class="custom-control custom-switch mb-4">
          <input id="hide-ai" v-model="form.hide_ai" type="checkbox" class="custom-control-input" />
          <label class="custom-control-label" for="hide-ai">
            {{ $t('admin.hide_ai') }}
          </label>
          <small class="form-text text-muted">{{ $t('admin.hide_ai_hint') }}</small>
        </div>

        <div class="alert alert-light border mb-4">
          <i class="fas fa-shield-alt mr-2 text-primary"></i>
          {{ $t('admin.features_admin_note') }}
        </div>

        <button type="submit" class="btn btn-primary" :disabled="saving">
          <i v-if="saving" class="fas fa-spinner fa-spin mr-1"></i>
          {{ $t('common.save') }}
        </button>
      </form>
    </ContentCard>
  </PageLayout>
</template>

<script>
import i18nPage from '@/mixins/i18nPage'
import { getIntegrations, updateIntegration } from '@/api/admin'

export default {
  mixins: [i18nPage],
  data() {
    return {
      loading: true,
      saving: false,
      form: {
        hide_scheduler: false,
        hide_ai: false,
      },
    }
  },
  async created() {
    await this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const { data } = await getIntegrations()
        const settings = data.data?.app || data.app || {}
        this.form = {
          hide_scheduler: !!settings.hide_scheduler,
          hide_ai: !!settings.hide_ai,
        }
      } catch (e) {
        this.$toast.error(this.$t('admin.features_load_failed'))
      } finally {
        this.loading = false
      }
    },
    async save() {
      this.saving = true
      try {
        await updateIntegration('app', this.form)
        await this.$store.dispatch('app/fetchFeatureSettings')
        this.$toast.success(this.$t('admin.features_saved'))
      } catch (e) {
        this.$toast.error(this.$t('admin.features_save_failed'))
      } finally {
        this.saving = false
      }
    },
  },
}
</script>
